/**
 * @generated SignedSource<<50c6b342e823af0b6e2964c7a116aeb3>>
 * @relayHash 660f12d35c241b52b01d580d0572723f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0535d95ef1d840747db0f0d185e2cd10b8069f176d338a8843dcb5ca9ab41369

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isValidationFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-improve-validation.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0535d95ef1d840747db0f0d185e2cd10b8069f176d338a8843dcb5ca9ab41369",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": isValidationFGEnabled_provider
    }
  }
};

export default node;
